import { Card, Image, Progress, Rate } from "antd"
import { useContext, useState } from "react"
import { useDispatch } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import Button from "src/components/MyButton/Button"
import { FAILBACK } from "src/constants/constants"
import STORAGE, { getStorage } from "src/lib/storage"
import { StoreContext } from "src/lib/store"
import { CourseItemStyle, StyleDetailCourse } from "../styled"
const { Meta } = Card

export const DetailService = ({ item }) => {
  const dispatch = useDispatch()
  const isLogin = getStorage(STORAGE.TOKEN)
  const [valueInput, setValueInput] = useState(1)
  const { routerStore } = useContext(StoreContext)
  const [, setRouterBeforeLogin] = routerStore
  const location = useLocation()
  const [loading, setLoading] = useState(false)
  const [openLoginModal, setOpenLoginModal] = useState(false)

  const onAdd = () => {
    // if (!isLogin) {
    //   setRouterBeforeLogin(`${location.pathname}${location?.search}`)
    //   setOpenLoginModal(true)
    // } else {
    //   setLoading(true)
    //   CartService.addProductToCart({
    //     PackageID: detail.PackageID,
    //     Quantity: valueInput,
    //     Examinations: examSelected?.map(i => i?.ExaminationID)?.join(","),
    //     Type:
    //       detail.PackageID === GUIDE_EMPTY ? location?.state?.type : undefined,
    //   })
    //     .then(res => {
    //       if (res.isOk) {
    //         getListCart()
    //         notification.open({
    //           placement: "top",
    //           top: "40%",
    //           message: (
    //             <img
    //               src={AddSuccess}
    //               alt="add-success"
    //               onClick={() => notification.destroy()}
    //             />
    //           ),
    //           style: {
    //             background: "transparent",
    //             overflow: "unset",
    //             boxShadow: "unset",
    //           },
    //           className: "destroy-close-icon",
    //           duration: 1,
    //           closeIcon: null,
    //           btn: null,
    //         })
    //       }
    //     })
    //     .finally(() => setLoading(false))
    // }
  }

  return (
    <StyleDetailCourse>
      <div className="course-title max-line2">{item?.CourseName}</div>
      <div className=" item-des mt-16 mb-16">
        {/* <ReactPlayer
          controls
          width={"350px"}
          height={"200px"}
          url={linkYoutube(item?.VideoIntro)}
        /> */}

        <div
          dangerouslySetInnerHTML={{
            __html: item?.Introduce,
          }}
        />
      </div>
      {/* <div style={{ width: "100%" }}>
        <Button
          className="btn-add-card"
          iconName="shopping-cart"
          btnType="third"
          style={{ width: "100%" }}
          onClick={() => onAdd()}
        >
          Thêm giỏ hàng
        </Button>
      </div> */}
    </StyleDetailCourse>
  )
}
const CourseItem = ({ item }) => {
  const navigate = useNavigate()
  return (
    <CourseItemStyle xs={24} md={12} lg={8} xl={6}>
      <Card
        className="card-course"
        onClick={() => navigate(`/chi-tiet-khoa-hoc/${item.CourseID}`)}
        style={{
          width: 300,
        }}
        cover={
          <div className="img-course d-flex-center">
            <Image
              alt="khoa-hoc"
              src={item.Img}
              className="img-user"
              fallback={FAILBACK}
              preview={false}
              style={{ height: 200, objectFit: "cover" }}
            />
            <div className="bg-course-name max-line1">{item?.CourseName}</div>
          </div>
        }
        // actions={[
        //   <SettingOutlined key="setting" />,
        //   <EditOutlined key="edit" />,
        //   <EllipsisOutlined key="ellipsis" />,
        // ]}
      >
        <Meta
          // avatar={
          //   <Avatar src="https://xsgames.co/randomusers/avatar.php?g=pixel" />
          // }
          title={
            <div className="max-line2">
              <div className="d-flex flex-column justify-content-space-between ">
                <div className="d-flex justify-content-space-between">
                  Giảng viên: {item?.TeacherCreate}
                </div>
                <div className="d-flex justify-content-space-between mt-0">
                  <div className="d-flex align-items-flex-end">
                    <Rate
                      disabled
                      allowHalf
                      defaultValue={item?.AverageEvaluate}
                      value={item?.AverageEvaluate}
                      style={{ fontSize: 14 }}
                    />
                    <div className="ml-6 fs-13">({item?.NumberEvaluate})</div>
                  </div>
                </div>
              </div>
            </div>
          }
          description={
            <div className="d-flex-sb pg-size">
              <Button btnType="primary">Vào học</Button>
              <Progress
                type="circle"
                percent={90}
                size="small"
                strokeColor={{
                  "0%": "#9CECFB",
                  "100%": "#0052D4",
                }}
              />
            </div>
          }
        />
      </Card>
    </CourseItemStyle>
  )
}

export default CourseItem
